import { AppCustomResponse } from '@models/custom';

const defaultCustomProps: AppCustomResponse = {
  main: {
    useBrandLogo: false,
    features: [],
    bannerPositions: [],
    navigationItems: [],
    mainFeature: 'QUICK_ORDER',
    useRecommendedItems: false,
  },
  popupBanner: {
    popupBannerType: 'MEDIUM',
  },
  membership: {
    useCouponButton: false,
  },
  shop: {
    shopImageShape: 'RECTANGLE',
    shopOrderButtonPosition: 'FIXED',
    components: [],
  },
  items: {
    gridColumns: 2,
    itemImageShape: 'RECTANGLE',
    itemBadgePosition: 'RIGHT',
  },
  item: {
    optionCollapsed: false,
    itemMaxQuantity: 10,
    itemOrderButtonPosition: 'FIXED',
  },
  payment: {
    requestMessages: [],
    paymentOrderButtonPosition: 'FIXED',
    paymentButtonType: 'NORMAL',
  },
  orderLog: {
    useOrderCancelButton: true,
  },
  coupon: {
    externalCouponUsePage: 'GIFT',
  },
};

export default defaultCustomProps;
